<template>
  <v-theme-provider>
    <base-section
      id="features"
      class="text-center"
      space="56"
    >
      <base-icon class="mb-8">
        mdi-cash-multiple
      </base-icon>

      <base-section-heading
        color="transparent"
        title="합리적인 경제성"
      >
        A4 출력비용보다 저렴한 서비스 사용료를 경험하세요.
      </base-section-heading>
      <v-responsive
        class="mx-auto"
        max-width="1000"
      />
      <v-row>
        <v-col cols="12">
          <v-img
            :src="require('@/assets/diagram-4.svg')"
            class="mx-auto mb-8"
            max-width="800"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col class="text-center">
          전통적으로 진행되던 건물의 운용관리 시 사용되는 관리일지의 경우 설비마다 하루  A4용지 2장과 약 116원의 출력비를 지불하고 있습니다.<p class="text--disabled">
            (※ S사 정품흑백토너 / A사 A4지 / 점검, 운전일지 사용 기준)
          </p>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="text-center">
          관리하고 있는 빌딩의 누적 관리일지 출력비는 년간 약 417만원의 비용이 사용되고 있습니다.<p class="text--disabled">
            (※ 지상8층, 지하2층 규모 / 100개의 설비 관리 시 예상 비용 / 전기비 및 장비 구매비는 제외)
          </p>
        </v-col>
      </v-row>
    </base-section>
  </v-theme-provider>
</template>

<script>
  export default {
    name: 'SectionFeatures',

    data: () => ({

    }),
  }
</script>
